import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IAisleQuery } from "../../../models/wms/aisle/query";
import { IAisle, IAisleDetails } from "../../../models/wms/aisle/response";
import { ICreateAisle, IUpdateAisle } from "../../../models/wms/aisle/request";

export type AisleLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: AisleLoading[];
  list?: IBaseListingResponse<IAisle>;
  query: IAisleQuery;
  details?: IAisleDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IAisleDetails) => void;
    createAisle: (request: ICreateAisle) => void;
    updateAisle: (id: number, request: IUpdateAisle) => void;
    deleteAisle: (id: number) => void;
    reorderAisle: (id: number, pickSequence: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IAisleQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createAisle: DEFAULT_FUNCTION,
    updateAisle: DEFAULT_FUNCTION,
    deleteAisle: DEFAULT_FUNCTION,
    reorderAisle: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const AisleContext = createContext(externalState);
export default AisleContext;
